import { Component, OnDestroy, OnInit, Inject, TemplateRef, ViewChild, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';

import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { ModalIdioma } from './modalIdioma.component';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import *  as $ from 'jquery';
import * as backInter from 'app/auth/auth-data.model';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';


interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};
interface langSel{
  clave?: string;
  name?: string;
  id: string;
  color?: string;
  langDestino?: number;
};

@Component({
  selector: 'app-idiomas',
  templateUrl: './idiomas.component.html',
  styleUrls: ['./idiomas.component.scss'],
  animations : fuseAnimations
})
export class IdiomasComponent implements OnInit {

  animal: string;
  name: string;
  visible = true;
  selectable = true;
  removable = true;

  langSteps: any[]= [
      {
          'id'      : '1',
          'title'   : 'CERTIFICAR.IDIOMAS.CARD1.TITULO',
          'slug'    : 'company',
          'category': 'CGO',
          'length'  : 30,
          'icon' : 'domain'
      },
      {
          'id'      : '2',
          'title'   : 'CERTIFICAR.IDIOMAS.CARD2.TITULO',
          'slug'    : 'user',
          'category': 'CGO',
          'length'  : 30,
          'icon' : 'person'
      }
  ];

  langs: any[] = [
    {id: 1, nombre: 'Inglés'},
    {id: 2, nombre: 'Español'},
    {id: 3, nombre: 'Chino'},
    {id: 4, nombre: 'Turco'}
  ];
  //numero de idiomas recuperados
  numLangs: number;
  //boolean cargando
  cargando = true;

  // Datos medir vigente
  productoMedir: backInter.prodMed;

  // IDIOMAS RECUPERADOS DE BD
  idiomas: backInter.getIdiomas;

  // LENGUAJE NATIVO
  langNat: any[] = [];

  // LENGUAJES adicionales
  langAdic: any[] = [];

  //boolean adicionales
  sinAdic = false;
  //id idioma "sin adicionales"
  idSinAdic: string;

  //boolean idiomas listos
  lang1Ok = false;
  lang2Ok = false;

  //boolean paso completo
  pasoCompleto = false;

  //mensaje a enviar al component wizard CGO
  mensajeEntreComponents: string;

  //etiquetas para encontrar los textos de traduccion
  mensajesTraducirKeys: string[] = [
    'CERTIFICAR.IDIOMAS.MENSAJES.ADDLANG',
    'CERTIFICAR.IDIOMAS.MENSAJES.NOADITIONAL',
    'CERTIFICAR.IDIOMAS.MENSAJES.ERRORADD',
    'CERTIFICAR.IDIOMAS.MENSAJES.LANGDEL',
    'CERTIFICAR.IDIOMAS.MENSAJES.NOADITIONALDEL',
    'CERTIFICAR.IDIOMAS.MENSAJES.ERRORDEL'
  ]
  //variables que tomaran las traducciones indicadas en la variable anterior
  //deben ir en el mismo orden
  mensajesTraducirTS = {
    addLang: '',
    noAdic: '',
    errAdd: '',
    delLang: '',
    delNoAd: '',
    errDel: ''
  };
  
  showswal(){
    
    Swal.fire({
      icon: 'success',
      title: 'Auto close alert!',
      html: '<h1></h1>',
      timer: 1500
    });
  }

  // message:string;
  // newMessage() {
  //   this.idiomasService.changeMessage("Hello from Second Component")
  // }

  constructor(
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private idiomasService: IdiomasService,
    private idiomaServiceN35:IdiomasServiceN35 ,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
  }

  ngOnInit() {
    this.traduceTextosTS();

    /// obtiene el producto medir vigente
    this.idiomasService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsMedir:backInter.prodMed[] = data.productosMedir;
      var BreakException = {};
      try {
          prodsMedir.forEach( (producto) => {
            let fecha = producto.fechaMedir;
            let idProducto = producto.idMedir;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoMedir = producto;
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso idiomas del medir vigente
      this.idiomasService.getStatusIdiomaMedir(this.productoMedir.idMedir).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
          this.pasoCompleto = true;
      });

      this.getListaIdiomas(this.productoMedir.idMedir);

      let fechaProducto: backInter.getIdiomaFechas = {productoId:this.productoMedir.idMedir};
      this.idiomasService.getIdiomasProdMedir(fechaProducto).subscribe( (data: backInter.getIdiomas) => {
        console.log(data);
        this.idiomas = data;
        this.colocaIdiomas();
      });
      this.getStatusModal();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getStatusModal(){
    let datos={
      productoId: this.productoMedir.idMedir,
      programacion: 1
    };
    //console.log(datos);
    this.wizardService.getStatusModalMedir(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
            this.modalInformativo('PROGRAMACION');
      }
    });
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoMedir.idMedir,
      programacion: 2
    };
    // console.log(datos);
    this.wizardService.updateStatusModalMedir(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  getListaIdiomas(productoId: string){
    //Obtiene la lista de idiomas del backend
    let datos:any = {productoId};
    this.idiomasService.getListaIdiomasMedir(datos).subscribe( (data: backInter.listaIdiomasBack) => {
      // console.log(data.idiomas);
      this.langs = [];
      let iter = 0;
      data.idiomas.forEach( (elemento) => {
        this.translateSrv.get('NOMBREIDIOMAS.'+elemento).subscribe((res: string) => {
          let idiomaRecuperado: any = {id:iter, nombre: res, clave:elemento};
          this.langs.push(idiomaRecuperado);
        });
        iter++;
      });
      // console.log(this.langs);
      this.numLangs = data.idiomas.length;
      this.quitaIdiomaArreglo();
    });
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }

    //traduce textos seleccionados
    if(this.langNat.length > 0){
      this.translateSrv.get('NOMBREIDIOMAS.'+this.langNat[0].clave).subscribe((res: string) => {
        this.langNat[0].name = res;
      });
    }
    if(this.langAdic.length > 0){
      let index = 0;
      this.langAdic.forEach( (elm) => {
        this.translateSrv.get('NOMBREIDIOMAS.'+elm.clave).subscribe((res: string) => {
          this.langAdic[index].name = res;
        });
        index++;
      });
    }

    //traduce textos traidos del backend
    let iterLangs = 0;
    this.langs.forEach( (lang) =>{
      this.translateSrv.get('NOMBREIDIOMAS.'+lang.clave).subscribe((res: string) => {
        this.langs[iterLangs].nombre = res;
      });
      iterLangs++;
    })
  }


  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  colocaIdiomas(){
    let iter = 0;
    this.idiomas.idiomasMostrar.forEach( (idioma: backInter.getIdiomaInd) => {
      this.translateSrv.get('NOMBREIDIOMAS.'+idioma.nombreIdioma).subscribe((res: string) => {
        // console.log("palabra traducida");
        // console.log(res);
        let langFront:langSel = { name: res, id: idioma._id, clave:idioma.nombreIdioma};
        if(idioma.tipoIdioma == "1"){
          langFront.langDestino = 1;
          this.langNat.push(langFront); this.lang1Ok = true;
        }
        else if(idioma.tipoIdioma == "0"){
          langFront.langDestino = 2;
          this.langAdic.push(langFront); this.lang2Ok = true;
        }
        else if(idioma.tipoIdioma == "3"){
          this.idSinAdic = idioma._id;
          this.sinAdicionales();
          //check idioma
          // console.log("debe checkear 'sin adicionales'");
        }
      });
      iter++;
      this.quitaIdiomaArreglo();
    });
    this.cargando = false;
  }

  openDialog(opcion?:any): void {
    if(!this.pasoCompleto){
      if(opcion == "x")
      {
        // const dialogRef = this.dialog.open(YaElegido, { width: '350px' });
        this.translateSrv.get('CERTIFICAR.IDIOMAS.MENSAJES.MAINPICKED').subscribe((res: string) => {
          Swal.fire({
            icon: 'warning',
            title: res,
            confirmButtonColor: '#e40601'
          });
        });
      }
      else{
        let dataModal: any;
        switch(opcion)
        {
          case '1': dataModal = {
                                  langDestino: 1,
                                  // tag: "Elige idioma principal",
                                  tag: "CERTIFICAR.IDIOMAS.CARD1.MODAL.TITULO",
                                  preg: "CERTIFICAR.IDIOMAS.CARD1.MODAL.ACCION"
                                };  break;
          case '2': dataModal = {
                                  langDestino: 2,
                                  tag: "CERTIFICAR.IDIOMAS.CARD2.MODAL.TITULO",
                                  preg: "CERTIFICAR.IDIOMAS.CARD2.MODAL.ACCION"
                                };  break;
        }
        const dialogRef = this.dialog.open(ModalIdioma, {
          width: '350px',
          data: {dataModal:dataModal, langs: this.langs}
        });

        //añade el idioma al cerrar la modal con mat-dialog-close
        dialogRef.afterClosed().subscribe(result => {
          switch(opcion){
            case '1': this.addLang(result,null); break;
            case '2': this.addLang(null,result); break;
          }

          // console.log(result);
        });
      }
    }
    else{
      this.alertaRestric2('IDIOMAS.RESTRICCION',null,'warning');
    }
  }

  /////// AÑADIR IDIOMAS
  addLang(langObj?:langSel, langObjs?:langSel[]): void{
    if(!this.pasoCompleto){
      if(langObj){
        this.enviaIdiomaBD(langObj,1,1);
      }
      else if(langObjs){
        langObjs.forEach( (elm) => {
          this.enviaIdiomaBD(elm,2,0);
        });
      }
    }
    else{
      this.alertaRestric2('IDIOMAS.RESTRICCION',null,'warning');
    }
  }

  enviaIdiomaBD(idioma:langSel, origen:number, tipo:number){
    // let idioma: any = { tipoIdioma:1, nombreIdioma:langObj.name, vivoIdioma: 1}
    let agregar: any = { tipoIdioma:tipo, nombreIdioma:idioma.clave, vivoIdioma: 1, idProducto:this.productoMedir.idMedir};
    this.idiomasService.guardaIdiomaProd(agregar).subscribe( (data:any) => {
      // this.idiomas = data;
      if(data.message == 200){
        idioma.id = data.idiomaMostrar._id;
        let mensaje = "";
        switch(origen){
          case 1: this.langNat.push(idioma);
                  this.lang1Ok = true;
                  mensaje = this.mensajesTraducirTS.addLang + idioma.name;
                  break;
          case 2: this.langAdic.push(idioma);
                  this.lang2Ok = true;
                  mensaje = this.mensajesTraducirTS.addLang + idioma.name;
                  break;
          case 3: this.idSinAdic = data.idiomaMostrar._id;
                  mensaje = this.mensajesTraducirTS.noAdic;
                  break;
        }
        this.openSnackBar(mensaje,"OK");
        // console.log(this.langNat);
        this.quitaIdiomaArreglo();
      }
      else{
        this.openSnackBar(this.mensajesTraducirTS.errAdd + idioma.name,"OK");
      }
    });
  }

  quitaIdiomaArreglo(){
    let idsBorrar:number[] = [];

    if(this.langNat.length > 0){
      idsBorrar.push(this.langNat[0].clave);
    }
    if(this.langAdic.length > 0){
      this.langAdic.forEach( (elm) => {
        idsBorrar.push(elm.clave);
      });
    }

    // console.log("ids a borrar del arreglo:");
    // console.log(idsBorrar);

    idsBorrar.forEach( (id) => {
      let index = 0;
      let BreakException = {};
      try{
        this.langs.forEach( (lang) => {
          if(lang.clave == id) throw BreakException;
          index++;
        });
      } catch (e) {
        if(e !== BreakException) throw e;
      }
      this.langs.splice(index,1);
    });
  }

  /////////REMOVER IDIOMAS
  remove(idioma: string, origen: number): void {
    if(!this.pasoCompleto){
      let index = 0;
      var BreakException = {};

      if(origen == 1){
        this.remueveIdiomaBD(this.langNat[0], 1);
      }
      else if(origen == 2){
        try {
            this.langAdic.forEach(function(elemento) {
              // console.log(elemento);
              if(elemento.name === idioma) throw BreakException;
              index++;
            });
        } catch (e) {
            if (e !== BreakException) throw e;
        }
        this.remueveIdiomaBD(this.langAdic[index], 2, index);
      }
    }
    else{
      this.alertaRestric2('IDIOMAS.RESTRICCION',null,'warning');
    }
  }
  remueveIdiomaBD(idioma:langSel, origen:number, indice?:number){
    // let idioma: any = { idiomaId:this.langNat[0].id }
    let borrar: any = { idiomaId:idioma.id };
    this.idiomasService.borraIdioma(borrar).subscribe( (data:any) => {
      // this.idiomas = data;
      if(data.message == '201'){
        let mensaje = "";
        switch(origen){
          case 1: this.langNat.splice(0,1);
                  this.lang1Ok = false;
                  mensaje = this.mensajesTraducirTS.delLang + idioma.name;
                  break;
          case 2: this.langAdic.splice(indice,1);
                  if(this.langAdic.length == 0)
                    this.lang2Ok = false;
                  mensaje = this.mensajesTraducirTS.delLang +idioma.name;
                  break;
          case 3: this.idSinAdic = null;
                  mensaje = this.mensajesTraducirTS.delNoAd ;
                  break;
        }
        this.openSnackBar(mensaje,"OK");
        // console.log(this.langNat);

        this.getListaIdiomas(this.productoMedir.idMedir);
      }
      else{
        this.openSnackBar(this.mensajesTraducirTS.errDel +idioma.name,"OK");
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  sinAdicionales(e?){
    if(!this.pasoCompleto){
      this.sinAdic = !this.sinAdic;
      this.lang2Ok = this.sinAdic;
      if(this.sinAdic){
        if(this.idSinAdic == null){
          let langSinAd: langSel = {name: "sin adicionales", id: '0'};
          this.enviaIdiomaBD(langSinAd,3,3);
        }
      }
      else{
        let langSinAd: langSel = {id: this.idSinAdic};
        this.remueveIdiomaBD(langSinAd,3);
      }
    }
    else{
      e.preventDefault();
      this.alertaRestric2('IDIOMAS.RESTRICCION',null,'warning');
    }
  }

  completarPaso(){
    if(this.pasoCompleto){
      this.alertaRestric2('IDIOMAS.COMPLETADO',null,'warning');
    }
    else{
      if(this.numLangs == 1){
        if(this.lang1Ok){
          if(!this.lang2Ok){
            this.sinAdicionales();
          }
          this.alertaRestric2('IDIOMAS.COMPLETAR',true);
        }
        else if(!this.lang1Ok){
          this.alertaRestric2('IDIOMAS.NODEFAULT',null,'warning');
        }
      }
      else{
        if(this.lang1Ok && this.lang2Ok){
          this.alertaRestric2('IDIOMAS.COMPLETAR',true);
        }
        else if(!this.lang1Ok && !this.lang2Ok){
          this.alertaRestric2('IDIOMAS.NADA',null,'warning');
        }
        else{
          if(!this.lang1Ok){
            this.alertaRestric2('IDIOMAS.NODEFAULT',null,'warning');
          }
          if(!this.lang2Ok){
            this.alertaRestric2('IDIOMAS.NOADICIONAL',null,'warning');
          }
        }
      }
    }

  }

  alertaRestric2(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.idiomasService.guardaStatusIdiomaMedir(this.productoMedir.idMedir).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '210'){
              this.alertaRestric2('IDIOMAS.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      if(tipo == 'warning'){
        Swal.fire({
          icon: 'warning',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });
      }
      else if(tipo == 'success'){
        this.openSnackBar(texto,"OK");
        /*Swal.fire({
          icon: 'success',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });*/
      }
    }

  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

}
////////////////////////////////

////// MENSAJE "IDIOMA YA ELEGIDO"
@Component({
  selector: 'YaElegido',
  template: `<h2 [innerHTML]="mensaje"></h2>`,
  styleUrls: ['./idiomas.component.scss']
})
export class YaElegido {

  mensaje:string = "Ya ha elegido el idioma nativo para la encuesta.<br><br>Para cambiarlo, quite el idioma seleccionado y elija el nuevo idioma.";

}
